































import { Component, Vue } from "vue-property-decorator";
import { Fragment } from "vue-fragment";
import ReportsFilter from "@/components/dashboard/reports.filter.component.vue";
import ReportsDashboardView from "@/components/dashboard/reports.dashboard.view.component.vue";
import { NewReportStore } from "@/store/NewReportStore";

@Component({
  props: {
    showDialog: Boolean,
    report: Object,
    reportSheet: Object,
    refetch: Function
  },
  components: {
    Fragment,

    ReportsFilter,
    ReportsDashboardView
  }
})
export default class Dashboard extends Vue {
  public mounted() {
    NewReportStore.fetchReportOverview();
  }
}
